module.exports = __webpack_public_path__ + "media/images/covid/icons/mask-79729e1952fb63d1ada74998a0a91820.svg";